define(function (require) {
    "use strict";

    var LEConfig = require("assets/config/le-env-conf");
    var { Logger, ConsoleAppender, RemoteLoggosAppender, RemoteLoggosBamAppender } = require('vue-infra');
    var LEResourceResolver = require("leResourceResolver");
    var logger = Logger.getLogger("LEFramework");

    function applyCsdsDomainOverride(originalUrl, urlType) {
      var csdsLoggosDomain = window.leCsdsDomains && window.leCsdsDomains.loggos;
      if (csdsLoggosDomain && typeof csdsLoggosDomain === 'string' && csdsLoggosDomain.length > 0) {
        try {
          var parsedUrl = new URL(originalUrl);
          var newUrl = `${parsedUrl.protocol}//${csdsLoggosDomain}${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;

          logger.info(`Overriding host for ${urlType} URL ${originalUrl} with CSDS domain: ${csdsLoggosDomain}. New URL: ${newUrl}`);
          return newUrl;
        } catch (e) {
          logger.error(
            `Error processing CSDS domain override '${csdsLoggosDomain}' for ${urlType} URL '${originalUrl}': ${e}. Falling back to default.`
          );
        }
      }
      return originalUrl;
    }

    function addLoggosBamAppender() {
      if (LEConfig.isBamSupportEnabled) {
        var accountId = LEResourceResolver.getCurrentAccountId();

        var bamRestStrUrl = LEResourceResolver.apiResources.LoggosBamRest.url;
        var bamRestStrUrlRep = bamRestStrUrl.replace('{accountId}', accountId);
        var restBamURL = LEResourceResolver.getUrl(bamRestStrUrlRep);
        restBamURL = applyCsdsDomainOverride(restBamURL, 'REST BAM');

        var loggosBAMAppender = new RemoteLoggosBamAppender();
        loggosBAMAppender.initialize({ rest: restBamURL });
        Logger.addAppender({ name: 'RemoteLoggosBamAppender', appender: loggosBAMAppender });
      }
    }

    function addLoggosAppenders() {
        //build wss url
        var wsURL = LEResourceResolver.getUrl(LEResourceResolver.apiResources.LoggosWs.url);

        //build rest url
        var accId = LEResourceResolver.getCurrentAccountId();
        var restStrUrl = LEResourceResolver.apiResources.LoggosRest.url;
        var addAccIdToRestUrl = restStrUrl.replace("{accountId}",accId);
        var restURL = LEResourceResolver.getUrl(addAccIdToRestUrl);

        wsURL = applyCsdsDomainOverride(wsURL, 'Loggos WS');
        restURL = applyCsdsDomainOverride(restURL, 'Loggos REST');

        var loggosAppender = new RemoteLoggosAppender();
        loggosAppender.initialize({ws: wsURL, rest: restURL});
        Logger.addAppender({name: "RemoteLoggosAppender", appender: loggosAppender});
    }

    function addDefaultAppenders() {
        Logger.addAppender({ name: "ConsoleAppender", appender: new ConsoleAppender() });
    }

    addDefaultAppenders();
    addLoggosAppenders();
    addLoggosBamAppender();
});
